'use client';
import TitleMain from '@/components/shared/TitleMain/TitleMain';
import { useEffect, useState } from 'react';
import { FaFire } from 'react-icons/fa';
import MainGraph from './MainGraph';

const GithubGraph = () => {
  const [contributions2025, setContributions2025] = useState([]);
  const [contributions2024, setContributions2024] = useState([]);
  const [totalContributions2025, setTotalContributions2025] = useState(0);
  const [totalContributions2024, setTotalContributions2024] = useState(0);
  const [maxStreak2025, setMaxStreak2025] = useState(0);
  const [maxStreak2024, setMaxStreak2024] = useState(0);

  const fetchContributions = async (
    year,
    setContributions,
    setTotalContributions,
    setMaxStreak
  ) => {
    try {
      const response = await fetch(
        `/api/github-contributions?year=${year}&timestamp=${new Date().getTime()}`
      );
      const data = await response.json();

      if (
        !data?.data?.user?.contributionsCollection?.contributionCalendar?.weeks
      ) {
        console.error(`Invalid data format for ${year}:`, data);
        return;
      }

      const weeks =
        data.data.user.contributionsCollection.contributionCalendar.weeks;
      const total = weeks.reduce(
        (sum, week) =>
          sum +
          week.contributionDays.reduce(
            (daySum, day) => daySum + day.contributionCount,
            0
          ),
        0
      );

      setTotalContributions(total);
      setContributions(weeks);

      let streak = 0,
        maxStreak = 0;
      weeks.forEach(week => {
        week.contributionDays.forEach(day => {
          if (day.contributionCount > 0) {
            streak++;
            if (streak > maxStreak) maxStreak = streak;
          } else {
            streak = 0;
          }
        });
      });

      setMaxStreak(maxStreak);
    } catch (error) {
      console.error(`Fetch error for ${year}:`, error);
    }
  };

  useEffect(() => {
    fetchContributions(
      2025,
      setContributions2025,
      setTotalContributions2025,
      setMaxStreak2025
    );
    fetchContributions(
      2024,
      setContributions2024,
      setTotalContributions2024,
      setMaxStreak2024
    );

    const now = new Date();
    const midnight = new Date(now);
    midnight.setHours(24, 0, 0, 0);
    const timeUntilMidnight = midnight.getTime() - now.getTime();

    const timer = setTimeout(() => {
      fetchContributions(
        2025,
        setContributions2025,
        setTotalContributions2025,
        setMaxStreak2025
      );
      fetchContributions(
        2024,
        setContributions2024,
        setTotalContributions2024,
        setMaxStreak2024
      );

      setInterval(() => {
        fetchContributions(
          2025,
          setContributions2025,
          setTotalContributions2025,
          setMaxStreak2025
        );
        fetchContributions(
          2024,
          setContributions2024,
          setTotalContributions2024,
          setMaxStreak2024
        );
      }, 24 * 60 * 60 * 1000);
    }, timeUntilMidnight);

    return () => clearTimeout(timer);
  }, []);

  const renderGraph = contributions => (
    <div className='grid grid-flow-col gap-1 auto-cols-max justify-center'>
      {contributions.map((week, weekIndex) => (
        <div key={weekIndex} className='flex flex-col gap-1'>
          {week.contributionDays.map((day, dayIndex) => (
            <div
              key={dayIndex}
              className='w-4 h-4 rounded-[4px] shadow-md shadow-black'
              style={{ backgroundColor: day.color || '#6a22a7' }}
              title={`${day.contributionCount} contributions on ${new Date(
                day.date
              ).toLocaleDateString('en-GB', {
                day: '2-digit',
                month: 'short',
                year: 'numeric',
              })}`}
            />
          ))}
        </div>
      ))}
    </div>
  );

  const renderStreakBadge = (totalContributions, maxStreak, year) => (
    <div
      key={year}
      className='mt-10 rounded-xl p-6 flex flex-col items-center cursor-pointer  transform transition duration-200 relative mb-6'
    >
      <h3 className='text-lg font-bold mb-4 text-gray-200'>
        Max Streak in {year}
      </h3>
      <div className='flex flex-col items-center space-y-4'>
        <div className='flex items-center justify-center w-24 h-24 bg-purple-800 rounded-full relative border-2 border-yellow-400'>
          <span className='text-3xl font-bold text-yellow-400'>
            {maxStreak}
          </span>
          <FaFire className='absolute -top-3 text-yellow-500 text-2xl bg-purple-800' />
        </div>
        <p className='text-gray-300 font-semibold mt-2'>
          {totalContributions
            ? `${totalContributions} Contributions`
            : 'Loading...'}
        </p>
      </div>
    </div>
  );

  const mainGraphProps = {
    totalContributions2025,
    maxStreak2025,
    contributions2025,
    totalContributions2024,
    maxStreak2024,
    contributions2024,
    renderStreakBadge,
    renderGraph,
  };

  return <MainGraph mainGraphProps={mainGraphProps} />;
};

export default GithubGraph;
